import { getParentNode } from '@udecode/plate';
import { BufferEditor } from '~/editor/BufferEditor/types.plate';
import { ParagraphElement } from '../nodes/ParagraphElement';

/**
 * Checks whether the node at the current selection
 * is a direct child of a paragraph node
 */
export const nodeIsChildOfParagraph = (editor: BufferEditor) => {
  if (editor.selection) {
    const parentNodeEntry = getParentNode(editor, editor.selection);
    return parentNodeEntry && parentNodeEntry[0].type === ParagraphElement.type;
  }
};
